import { render, staticRenderFns } from "./ServerError.vue?vue&type=template&id=7895ef6d&scoped=true"
import script from "./ServerError.vue?vue&type=script&lang=js"
export * from "./ServerError.vue?vue&type=script&lang=js"
import style0 from "./ServerError.vue?vue&type=style&index=0&id=7895ef6d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7895ef6d",
  null
  
)

export default component.exports